import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import type { StringifiableRecord } from "query-string";

import { acceptFeeTermsLink } from "../core/apiLink";

export namespace ApiAcceptFeeTermsInfo {
  export interface IGetAcceptFeeTermsResponse {
    ifNeedAcceptance: boolean;
    ifAccept: boolean;
    priceSetting?: {
      threshold: number;
      percentage: number;
    };
    ifInPromotion: boolean;
    ifAllSellersActivatedInbound: boolean;
  }

  type IGetAcceptanceResponse = {
    data: IGetAcceptFeeTermsResponse;
    success: boolean;
  };

  export interface IPostEnableAllResponse {
    success: boolean;
    message?: string;
  }

  export const getAcceptInfo = (params: StringifiableRecord) =>
    baseFetch<StringifiableRecord, IGetAcceptanceResponse>({
      method: "GET",
      url: acceptFeeTermsLink,
      useSessionAccountId: true,
      params,
    });

  export const acceptFeeTerms = (params: StringifiableRecord) => {
    return baseFetch<StringifiableRecord, IPostEnableAllResponse>({
      method: "POST",
      url: getUrlWithSearchParams(acceptFeeTermsLink, params),
      useSessionAccountId: true,
      params,
    });
  };
}
